import eventBus from "@/helpers/eventBus";

// A removal that failed has to say so: until now the three remove buttons only
// logged to the console. When the server says the product is not in the order,
// the cart on screen is out of date, so the order page reloads it.
export const reportRemoveFailure = (error, showToast) => {
  console.error(error);
  showToast({
    message:
      error.response?.data?.message || "לא הצלחנו להסיר את המוצר. נסו שוב",
    type: "error",
  });
  if (error.response?.data?.code === "item_not_in_order") {
    eventBus.emit("cartOutOfSync");
  }
};
